export const INDIAN_MOBILE_REGEX = /^[6-9]\d{9}$/;
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const GST_REGEX =
  /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
export const PAN_REGEX = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
export const PARTY_NAME_REGEX = /^[A-Za-z\s.'-]+$/;
export const PARTY_CODE_REGEX = /^[A-Z0-9]{2,20}$/;
export const IFSC_REGEX = /^[A-Z]{4}0[A-Z0-9]{6}$/;
export const ACCOUNT_NUMBER_REGEX = /^\d+$/;

export function normalizeDigitsOnly(value: string): string {
  return value.replace(/\D/g, '');
}

export function normalizeGst(value: string): string {
  return value.replace(/\s/g, '').toUpperCase();
}

export function normalizePan(value: string): string {
  return value.replace(/\s/g, '').toUpperCase();
}

export function normalizeIfsc(value: string): string {
  return value.replace(/\s/g, '').toUpperCase();
}

export function normalizePartyName(value: string): string {
  return value.replace(/\s+/g, ' ').trim();
}

export function isValidIndianMobile(value: string | null | undefined): boolean {
  const v = normalizeDigitsOnly(value?.trim() ?? '');
  return INDIAN_MOBILE_REGEX.test(v);
}

export function isValidEmail(value: string | null | undefined): boolean {
  const v = value?.trim() ?? '';
  if (!v) return true;
  return EMAIL_REGEX.test(v);
}

export function isValidGst(value: string | null | undefined): boolean {
  const v = normalizeGst(value?.trim() ?? '');
  if (!v) return true;
  return GST_REGEX.test(v);
}

export function isValidPan(value: string | null | undefined): boolean {
  const v = normalizePan(value?.trim() ?? '');
  if (!v) return true;
  return PAN_REGEX.test(v);
}

export function isValidFirstName(value: string | null | undefined): boolean {
  const v = normalizePartyName(value ?? '');
  return v.length >= 1 && v.length <= 100 && PARTY_NAME_REGEX.test(v);
}

export function isValidLastName(value: string | null | undefined): boolean {
  const v = normalizePartyName(value ?? '');
  if (!v) return true;
  return v.length <= 100 && PARTY_NAME_REGEX.test(v);
}

export function isValidPartyCode(value: string | null | undefined): boolean {
  const v = (value?.trim() ?? '').toUpperCase();
  return PARTY_CODE_REGEX.test(v);
}

export function isValidIfsc(value: string | null | undefined): boolean {
  const v = normalizeIfsc(value?.trim() ?? '');
  if (!v) return true;
  return IFSC_REGEX.test(v);
}

export function isValidAccountNumber(value: string | null | undefined): boolean {
  const v = normalizeDigitsOnly(value?.trim() ?? '');
  if (!v) return true;
  return v.length <= 100 && ACCOUNT_NUMBER_REGEX.test(v);
}

export function formatStateLabel(
  stateName?: string | null,
  stateCode?: string | null,
): string {
  const name = stateName?.trim() ?? '';
  const code = stateCode?.trim() ?? '';
  if (name && code) return `${name} - ${code}`;
  return name || code;
}
